// Use process on development and window on production
const useWindowVariables =
  process.env.NODE_ENV === 'production' && typeof window !== 'undefined'

export const config = {
  iamBaseUrl: useWindowVariables
    ? window.env.GATSBY_API_IAM_BASE_URL
    : process.env.GATSBY_API_IAM_BASE_URL,
  dodoBaseApiURL: useWindowVariables
    ? window.env.GATSBY_API_DODO_BASE_URL
    : process.env.GATSBY_API_DODO_BASE_URL,
  loginPortalURL: useWindowVariables
    ? window.env.GATSBY_LOGIN_PORTAL
    : process.env.GATSBY_LOGIN_PORTAL,
  dodoDashboardBaseURL: useWindowVariables
    ? window.env.GATSBY_DODO_DASHBOARD_BASE_URL
    : process.env.GATSBY_DODO_DASHBOARD_BASE_URL,
  gtmContainer: useWindowVariables
    ? window.env.GATSBY_GTM_CONTAINER
    : process.env.GATSBY_GTM_CONTAINER,
}
